// Visit The Stimulus Handbook for more details 
import { Controller } from "stimulus"

export default class extends Controller {
  static values = { icon: String }

  connect() { 
    //console.log("Day Map js loaded")
  } 

  toggle() {
    //console.log("Icon zIndex Toggle", this.iconValue)
    let raised = document.querySelectorAll('.leaflet-marker-pane > .mi-raised')
    //console.log("Raised", raised.length)
    if (raised.length > 0) {
      //console.log("Unraising")
      raised.forEach( function(el) { 
        el.style.zIndex = Number(el.style.zIndex) - 1000 
        el.classList.remove('mi-raised')
      })
    }
    else {
      //console.log("Raising")
      let icons = document.querySelectorAll('.leaflet-marker-pane > .'+this.iconValue)
      //console.log(" icons " , icons.length)
      icons.forEach( function(el) {
        el.classList.add('mi-raised')
        el.style.zIndex = Number(el.style.zIndex) + 1000
      })
    }
  }  

}
